<template>
    <div class="full-height">
        <div class="container-fluid full-height">
            <div class="row full-height">
                <v-app>
                <div id='mainChartArea' class="col-md-8 full-height"></div>
                <div class="col-md-4 full-height optionsTab">
                    <div class="col-md-9" id="divLogo">
                        <img id="logo" class="img-responsive" src="../assets/LCP_eXcYte_final.png" alt="Responsive image">
                    </div>
                    <input-section headerClass="header" subheaderClass="white sub-header"></input-section>
                    <div class="col-md-12 titles">
                        <summary-section headerClass="header" subheaderClass="white sub-header" toolbarClass="white toolbar-no-shadow content-color"></summary-section>
                    </div>
                    <div class="col-md-12 titles">
                        <box-tools styleClass="header"></box-tools>
                    </div>
                </div>
                </v-app>                
            </div>
        </div>
    </div>
</template>

<script>
    import boxTools from '@/components/boxTools.vue';
    import summarySection from '@/components/summarySection.vue';
    import inputSection from '@/components/inputSection.vue';

    export default {
        components: {
            boxTools,
            summarySection,
            inputSection
        }
    };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .header {
        background-color: #032f5e!important;
        color: white!important;
    }

    .sub-header {
        color: #032f5e!important;
        border-color: 1px solid black!important;
    }
    .content-color{
        color: #032f5e!important;
    }
    .full-height {
        height: 100%;
    }

    .titles {
        margin-top: 20px;
    }

    .toolbar-no-shadow {
        box-shadow: 0 0px 0px rgba(0, 0, 0, 0)!important;
    }
    /*chart*/

    body {
        font-family: Helvetica, Ariel, Sans-Serif !important;
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Chrome/Safari/Opera */
        -khtml-user-select: none;
        /* Konqueror */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently */
        overflow-x: hidden;
    }

    .optionsTab {
        background-color: #ffffff;
        overflow-y: scroll;
        padding-bottom: 15px;
    }

    #mainChartArea {
        background-color: #ffffff;
    }

    .ex3::-webkit-scrollbar {
        width: 5px;
        background-color: transparent;
    }

    .ex3::-webkit-scrollbar-thumb {
        background-color: #032f5e;
        border-radius: 7px;
    }

    .ex3::-webkit-scrollbar-thumb:hover {
        background-color: #02254a;
    }

    #ex3::-webkit-scrollbar-thumb:active {
        background-color: #02254a;
    }

    #logo {
        width: 100%;
        margin: -5% 0;
    }

    @media (min-width: 1000px) {
        #logo {
            max-width: 350px;
            margin: -20px 0 -20px -28px;
        }
    }

    .axis line {
        stroke: #000;
        shape-rendering: crispEdges;
    }

    .chartText {
        color: #032f5e;
        fill: #032f5e;
        font-family: Helvetica, Ariel, Sans-Serif !important;
    }

    .axis path {
        fill: none;
        stroke: #032f5e;
        stroke-width: 2px;
        shape-rendering: crispEdges;
    }

    .chartBackground {
        fill: white;
    }

    .box {
        fill: none;
        fill-opacity: 0.0;
        stroke: #8B37CC;
        stroke-opacity: 1;
        stroke-width: 3;
    }

    .selectedBox {
        fill-opacity: 0;
        filter: alpha(opacity=25);
        /* For IE8 and earlier */
        stroke: red;
    }

    .zoomedBox {
        stroke-width: 0px !important;
    }


    .fullHeight {
        height: 99%;
    }

    @media (max-width: 992px) {
        .fullHeight {
            height: inherit;
        }
    }
    /* Popover */
    .popover:not(.modal *) {
        text-shadow: none;
        opacity: 0.5;
        /*border: 2px dotted red;*/
    }

    /* Popover Header */
    .popover-title {
        background-color: #032f5e !important;
        color: white;
        font-size: 14px;
        text-align: center;
    }

    h3.popover-title {
        margin-top: 0 !important;
    }

    /* Popover Body */
    .popover-content {
        background-color: white;
        color: #032f5e;
        font-size: 14px;
        padding: 10px;
        text-shadow: none;
        max-height: 80vh;
        overflow-y: auto;
    }

    .popover-content ul {
        list-style-position: inside;
        padding-left: 0;
    }

    /* Popover Arrow */
    .arrow {
        border-right-color: #032f5e !important;
    }

    .inputPanel {
        background-color: #032f5e;
        overflow-y: hidden;
        overflow-x: hidden;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?60577de0